import { Image, Result, Button } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { images_folder, doVerifyAccount, getURL } from "./client";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

const VerifyAccount = (props) => {
  const [isVerified, setIsVerified] = useState(false);
  const [executed, setExecuted] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const verification_code = queryParameters.get("verification_code");
    const email = queryParameters.get("email");
    const PATH = process.env.PUBLIC_URL.replace(document.location.origin, "");
    if (verification_code && email && !executed) {
      props.setSpin(true);
      setExecuted(true);
      doVerifyAccount({ verification_code: verification_code, email: email })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === 1) {
            setIsVerified(true);
          } else {
            navigate(PATH + "/");
          }
        })
        .finally(() => {
          props.setSpin(false);
        });
    }
    if (!verification_code || !email) {
      navigate(PATH + "/");
    }
  }, [props, executed, navigate]);

  return isVerified ? (
    <>
      <SiteHeader headerType="create-account" />
      <br />
      <Result
        style={{ maxWidth: "450px", margin: "45px auto", width: "100%" }}
        status="success"
        title="Account Verification Complete"
        subTitle="You may sign in now"
        extra={[
          <Link key="verify-complete" to={getURL("/")}>
            <Button type="primary" className="login-form-button">
              Sign in
            </Button>
          </Link>,
        ]}
      />

      <SiteFooter />
    </>
  ) : null;
};

export default VerifyAccount;
